import type { IUser } from '~/entities/user/user/interfaces/user'

import type { IEntity } from '~/features-shared/libs/interfaces/entity'

export enum EDmType {
  Private = 'private',
  Group = 'group',
}

/** Automatic removal of conversation. '0': Disabled | '1': Activated. */
export enum EDmAutoRemoval {
  Disabled = '0',
  Activated = '1',
}

export interface IConversationLastMessage {
  message_id: string
  message_content?: string
  message_type?: 'INTERNAL_EVENT' | 'INTERNAL_CONTENT' | 'INSTANT_MESSAGE'
  model?: 'Comment' | 'Answer' | '' | string
  message_title?: string
  media_type?: string
  media_ext?: string
}
export interface IConversation extends IEntity {
  community_type: 'dm'
  is_hidden: boolean
  is_muted?: boolean
  topic: string
  last_message?: IConversationLastMessage
  mark?: {
    message_id: string
  }
  users: IUser[]
  dm_type: EDmType
  is_persistent: boolean
  /** First question. For AI use only. */
  firstQuestion?: string
  /** Position of conversation in section */
  position?: number
}

export type IConversationMark = Pick<IConversation, 'id' | 'subject_uri' | 'mark' | 'last_message'>

/** Interface to create a conversation. */
export interface CreateConversationOptions {
  /** Users login. */
  users: string[]
  /** Conversation's title. */
  title?: string
}
